// Participant-facing company profiles (demo content; logos are typographic placeholders).
import { COMPANIES } from "./seed";
export const PROFILES = {
  bosch: {
    logo: { text: "BOSCH", color: "#E20015", cls: "font-extrabold tracking-tight" },
    jobs: [
      ["Ingeniero/a de Software", "Empleo", "Tecnología", ["Ingeniería Informática", "Telecomunicaciones"]],
      ["Ingeniero/a de Sistemas Embebidos", "Prácticas", "Ingeniería", ["Telecomunicaciones", "Ingeniería Eléctrica"]],
      ["Ingeniero/a de Producción", "Programa graduados", "Producción", ["Ingeniería Industrial"]],
    ],
    desc: {
      es: "Tecnología e ingeniería al servicio de la movilidad, la industria y el hogar. En el Foro buscamos talento en software, electrónica e ingeniería industrial para proyectos internacionales.",
      pt: "Tecnologia e engenharia ao serviço da mobilidade, da indústria e da casa. Na Feira procuramos talento em software, eletrónica e engenharia industrial para projetos internacionais.",
      en: "Technology and engineering for mobility, industry and the home. At the fair we are looking for talent in software, electronics and industrial engineering for international projects.",
      fr: "Technologie et ingénierie au service de la mobilité, de l'industrie et de la maison. Au Forum, nous recherchons des talents en logiciel, électronique et génie industriel pour des projets internationaux.",
    },
  },
  siemens: {
    logo: { text: "SIEMENS", color: "#009999", cls: "font-extrabold tracking-wide" },
    jobs: [
      ["Ingeniero/a de Automatización", "Empleo", "Ingeniería", ["Ingeniería Industrial", "Ingeniería Eléctrica"]],
      ["Ingeniero/a de Ciberseguridad", "Prácticas", "Tecnología", ["Ingeniería Informática", "Telecomunicaciones"]],
      ["Ingeniero/a de Datos", "Programa graduados", "Datos", ["Ciencia de Datos", "Ingeniería Informática"]],
    ],
    desc: {
      es: "Industria, infraestructuras y energía impulsadas por la digitalización. Buscamos perfiles de ingeniería que quieran trabajar en automatización y transformación digital.",
      pt: "Indústria, infraestruturas e energia impulsionadas pela digitalização. Procuramos perfis de engenharia que queiram trabalhar em automação e transformação digital.",
      en: "Industry, infrastructure and energy driven by digitalisation. We are looking for engineering profiles eager to work in automation and digital transformation.",
      fr: "Industrie, infrastructures et énergie portées par la digitalisation. Nous recherchons des profils d'ingénieurs souhaitant travailler dans l'automatisation et la transformation numérique.",
    },
  },
  ford: {
    logo: { text: "Ford", color: "#003478", cls: "font-bold italic tracking-tight" },
    jobs: [
      ["Ingeniero/a de Vehículo Eléctrico", "Empleo", "Ingeniería", ["Ingeniería Eléctrica", "Ingeniería Industrial"]],
      ["Ingeniero/a de Calidad", "Prácticas", "Producción", ["Ingeniería Industrial", "Ingeniería Química"]],
      ["Ingeniero/a de Producción", "Programa graduados", "Producción", ["Ingeniería Industrial"]],
    ],
    desc: {
      es: "Diseño, producción e innovación en automoción. Buscamos ingenieros e ingenieras para la planta y para el desarrollo del vehículo eléctrico.",
      pt: "Design, produção e inovação no setor automóvel. Procuramos engenheiros e engenheiras para a fábrica e para o desenvolvimento do veículo elétrico.",
      en: "Design, production and innovation in the automotive industry. We are looking for engineers for the plant and for electric vehicle development.",
      fr: "Conception, production et innovation dans l'automobile. Nous recherchons des ingénieur·e·s pour l'usine et le développement du véhicule électrique.",
    },
  },
  deloitte: {
    logo: { text: "Deloitte", color: "#0F172A", cls: "font-bold tracking-tight", dot: "#86BC25" },
    jobs: [
      ["Consultor/a de Negocio", "Programa graduados", "Consultoría", ["Administración y Dirección de Empresas", "Ingeniería Industrial"]],
      ["Analista Financiero/a", "Prácticas", "Finanzas", ["Administración y Dirección de Empresas"]],
      ["Consultor/a Tecnológico/a", "Empleo", "Tecnología", ["Ingeniería Informática", "Ciencia de Datos"]],
    ],
    desc: {
      es: "Consultoría, auditoría y asesoramiento para organizaciones de todos los sectores. Buscamos perfiles analíticos para nuestros equipos de consultoría de negocio y tecnología.",
      pt: "Consultoria, auditoria e assessoria para organizações de todos os setores. Procuramos perfis analíticos para as nossas equipas de consultoria de negócio e tecnologia.",
      en: "Consulting, audit and advisory services for organisations in every sector. We are looking for analytical profiles for our business and technology consulting teams.",
      fr: "Conseil, audit et accompagnement pour des organisations de tous secteurs. Nous recherchons des profils analytiques pour nos équipes de conseil métier et technologique.",
    },
  },
  "power-electronics": {
    logo: { text: "POWER ELECTRONICS", color: "#0B3D91", cls: "font-extrabold tracking-tight leading-none" },
    jobs: [
      ["Ingeniero/a de Electrónica de Potencia", "Empleo", "Ingeniería", ["Ingeniería Eléctrica", "Telecomunicaciones"]],
      ["Ingeniero/a de Proyectos Energéticos", "Programa graduados", "Energía", ["Ingeniería Industrial", "Ingeniería Eléctrica"]],
      ["Ingeniero/a de Software", "Prácticas", "Tecnología", ["Ingeniería Informática"]],
    ],
    desc: {
      es: "Electrónica de potencia para energías renovables y movilidad eléctrica. Buscamos talento en ingeniería eléctrica, electrónica e industrial.",
      pt: "Eletrónica de potência para energias renováveis e mobilidade elétrica. Procuramos talento em engenharia eletrotécnica, eletrónica e industrial.",
      en: "Power electronics for renewable energy and electric mobility. We are looking for talent in electrical, electronic and industrial engineering.",
      fr: "Électronique de puissance pour les énergies renouvelables et la mobilité électrique. Nous recherchons des talents en génie électrique, électronique et industriel.",
    },
  },
  capgemini: {
    logo: { text: "Capgemini", color: "#0070AD", cls: "font-semibold tracking-tight" },
    jobs: [
      ["Desarrollador/a Cloud", "Empleo", "Tecnología", ["Ingeniería Informática", "Telecomunicaciones"]],
      ["Ingeniero/a de Datos", "Prácticas", "Datos", ["Ciencia de Datos", "Ingeniería Informática"]],
      ["Consultor/a Tecnológico/a", "Programa graduados", "Consultoría", ["Ingeniería Industrial", "Administración y Dirección de Empresas"]],
    ],
    desc: {
      es: "Consultoría tecnológica y servicios digitales. Buscamos desarrolladores, ingenieros de datos y consultores para proyectos de transformación digital.",
      pt: "Consultoria tecnológica e serviços digitais. Procuramos programadores, engenheiros de dados e consultores para projetos de transformação digital.",
      en: "Technology consulting and digital services. We are looking for developers, data engineers and consultants for digital transformation projects.",
      fr: "Conseil technologique et services numériques. Nous recherchons des développeurs, des ingénieurs données et des consultants pour des projets de transformation numérique.",
    },
  },
  accenture: {
    logo: { text: "accenture", color: "#A100FF", cls: "font-bold tracking-tight lowercase", mark: ">" },
    jobs: [
      ["Consultor/a Tecnológico/a", "Programa graduados", "Consultoría", ["Ingeniería Informática", "Telecomunicaciones"]],
      ["Ingeniero/a de Datos", "Empleo", "Datos", ["Ciencia de Datos"]],
      ["Diseñador/a UX/UI", "Prácticas", "Diseño", ["Ingeniería Informática", "Administración y Dirección de Empresas"]],
    ],
    desc: {
      es: "Consultoría, tecnología y operaciones. Buscamos perfiles tecnológicos y de negocio para proyectos de cloud, datos e inteligencia artificial.",
      pt: "Consultoria, tecnologia e operações. Procuramos perfis tecnológicos e de negócio para projetos de cloud, dados e inteligência artificial.",
      en: "Consulting, technology and operations. We are looking for technology and business profiles for cloud, data and artificial intelligence projects.",
      fr: "Conseil, technologie et opérations. Nous recherchons des profils technologiques et métier pour des projets cloud, données et intelligence artificielle.",
    },
  },
  "mercadona-tech": {
    logo: { text: "Mercadona Tech", color: "#00843D", cls: "font-bold tracking-tight" },
    jobs: [
      ["Desarrollador/a Mobile", "Empleo", "Tecnología", ["Ingeniería Informática"]],
      ["Ingeniero/a de Software", "Programa graduados", "Tecnología", ["Ingeniería Informática", "Telecomunicaciones"]],
      ["Ingeniero/a de Datos", "Prácticas", "Datos", ["Ciencia de Datos"]],
    ],
    desc: {
      es: "El equipo tecnológico que desarrolla los productos digitales de Mercadona. Buscamos personas que quieran construir software de calidad con impacto real.",
      pt: "A equipa tecnológica que desenvolve os produtos digitais da Mercadona. Procuramos pessoas que queiram construir software de qualidade com impacto real.",
      en: "The technology team building Mercadona's digital products. We are looking for people who want to build quality software with real impact.",
      fr: "L'équipe technologique qui développe les produits numériques de Mercadona. Nous recherchons des personnes souhaitant créer des logiciels de qualité à fort impact.",
    },
  },
};

export const companyImage = (id) => `/companies/${id}.jpg`;

export const appCompany = (a) => ({
  id: a.id, name: a.name, sector: a.sector, stand: a.stand, image: a.cover || "/img/registro-hero.jpg", desc: a.description,
  logo: a.logoImg ? { img: a.logoImg } : { text: a.name.replace(/\s+S\.[LA]\.?$/i, ""), color: a.brandColor || "#8B0000", cls: "font-bold tracking-tight" },
  jobs: a.offers.filter((o) => o.title).map((o) => [o.title, o.type, o.area || a.sector, o.titulaciones?.length ? o.titulaciones : a.titulaciones, o.location]),
});

export const directoryCompanies = (state) => [
  ...COMPANIES.map((c) => ({ ...c, image: companyImage(c.id), logo: PROFILES[c.id].logo, desc: PROFILES[c.id].desc, jobs: PROFILES[c.id].jobs })),
  ...state.companyApplications.filter((a) => a.status === "approved").map(appCompany),
];
